import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY as string;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export const ADMIN_EMAIL = 'websitetrochoidangianbahnar@gmail.com';

export function isAdminEmail(email: string | undefined | null): boolean {
  return email?.toLowerCase().trim() === ADMIN_EMAIL.toLowerCase();
}
